export const adaptersLimits = {
  ACH: {
    currency: 'USD',
    min: 1,
    max: 10000000,
  },
  DD: {
    currencies: ['EUR'],
    currency: 'EUR',
    min: 2,
  },
  EFT: {
    currency: 'CAD',
    min: 1,
    max: 10000000,
  },
  DEFAULT: {
    min: 1,
    max: Number.MAX_VALUE,
  },
};
